import axiosInstance from '../utils/axiosInstance';

export const createAdmin = async (adminData) => {
  const response = await axiosInstance.post('/auth/admin/create', adminData);
  return response.data;
};
export const getAdmins = async () => {
  const response = await axiosInstance.get('/auth/admin/list');
  return response.data;
};
// Update admin
export const updateAdmin = async (adminId, adminData) => {
  const response = await axiosInstance.put(`/auth/admin/update/${adminId}`, adminData);
  return response.data;
};
export const deleteAdmin = async (adminId) => {
  const response = await axiosInstance.delete(`/auth/admin/${adminId}`);
  return response.data;
};
export const toggleAdminStatus = async (adminId, status) => {
  const response = await axiosInstance.put('/auth/toggle-status', { adminId, status });
  return response.data;
};